import { render, staticRenderFns } from "./TemplateField.vue?vue&type=template&id=d987b3be&scoped=true"
import script from "./TemplateField.vue?vue&type=script&lang=js"
export * from "./TemplateField.vue?vue&type=script&lang=js"
import style0 from "./TemplateField.vue?vue&type=style&index=0&id=d987b3be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d987b3be",
  null
  
)

export default component.exports